import { z } from 'zod';
import { DraftNodeEnvelopeSchema } from '../../entities/process-draft';
/**
 * Mode-switch endpoint: move the record from `draftAssignments` into `steps`
 * while preserving stashed assignee content so the user can flip back without
 * losing work. The kind-swap surfaces in the response envelope as the node
 * under its NEW kind (`'step'`) — never in `deletedNodeIds`.
 */ export const convertAssignmentToStepContract = {
    method: 'POST',
    path: '/api/v2/process/:processId/draft/assignments/:stableStepId/convert-to-step',
    description: 'Move an existing draft assignment into the draft steps collection; assignee is stashed for a round-trip back.',
    requestSchema: z.object({}),
    responseSchema: DraftNodeEnvelopeSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Draft assignment not found'
        }
    }
};

//# sourceMappingURL=convert-draft-assignment-to-step.contract.js.map